import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { Flag } from '../guides';

export type ListUserFlagsResult = {
   guide: Record<string, Flag>;
};

export function listUserFlags({ ...common }: CommonRequestOptions): Promise<ListUserFlagsResult> {
   return makeRequest('get', 'user/flags', {
      ...common,
   });
}
